import { z } from "zod";
export const GroupReferencePaywallTrigger = z.object({
    kind: z.literal("paywallTrigger"),
    object: z.object({
        paywallTriggerId: z.number()
    })
});
export const GroupReferenceApplication = z.object({
    kind: z.literal("application"),
    object: z.object({
        applicationId: z.number()
    })
});
export const GroupReferencePaywall = z.object({
    kind: z.literal("paywall"),
    object: z.object({
        paywallId: z.number()
    })
});
export const GroupReferenceSurvey = z.object({
    kind: z.literal("survey"),
    object: z.object({
        surveyId: z.number()
    })
});
export const GroupReferenceTriggerExperimentGroup = z.object({
    kind: z.literal("triggerExperimentGroup"),
    object: z.object({
        triggerExperimentGroupId: z.number()
    })
});
export const GroupReferenceTriggerExperiment = z.object({
    kind: z.literal("triggerExperiment"),
    object: z.object({
        triggerExperimentId: z.number()
    })
});
export const GroupReferenceExperiment = z.object({
    kind: z.literal("experiment"),
    object: z.object({
        experimentId: z.number()
    })
});
export const GroupReferenceVariant = z.object({
    kind: z.literal("variant"),
    object: z.object({
        variantId: z.number()
    })
});
// Used for events that really don't have a group
export const GroupReferenceNone = z.object({
    kind: z.literal("none"),
    object: z.object({})
});
export const GroupReferenceOrganization = z.object({
    kind: z.literal("organization"),
    object: z.object({
        organizationId: z.number()
    })
});
export const GroupReference = z.discriminatedUnion("kind", [
    GroupReferenceApplication,
    GroupReferenceExperiment,
    GroupReferencePaywallTrigger,
    GroupReferencePaywall,
    GroupReferenceSurvey,
    GroupReferenceTriggerExperimentGroup,
    GroupReferenceTriggerExperiment,
    GroupReferenceVariant,
    GroupReferenceOrganization,
    GroupReferenceNone
]);
